import { SegmentedControl } from "@sportsmet/ui";
import { useEffect, useRef } from "react";

/** A single segmented track that can scroll without squeezing overtime labels. */
export function PlaysPeriodSelector(props: {
  options: { value: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    ref.current
      ?.querySelector('[aria-checked="true"]')
      ?.scrollIntoView?.({ block: "nearest", inline: "nearest" });
  }, [props.value]);
  const segmentWidth = Math.max(
    120,
    ...props.options.map((option) => option.label.length * 8 + 32),
  );
  return (
    <div
      ref={ref}
      className="max-w-full overflow-x-auto"
      data-testid="plays-period-selector"
    >
      <div style={{ minWidth: props.options.length * segmentWidth }}>
        <SegmentedControl
          label="Period"
          fullWidth
          options={props.options}
          value={props.value}
          onValueChange={props.onChange}
        />
      </div>
    </div>
  );
}
